import { NgModule } from "@angular/core";
import { AppleLinkPipe } from "../../../pipe/apple-link.pipe";
import { AndroidLinkPipe } from "../../../pipe/android-link.pipe";

@NgModule({
    declarations: [AppleLinkPipe, AndroidLinkPipe],
    exports: [AppleLinkPipe, AndroidLinkPipe],
})
export class AppLinkPipesModule {}
